<template>
  <div style="display: flex; flex-direction: column;justify-content: center; align-items: center;">
    <v-toolbar dark :color="$bgColor" :style="'height:50px;width:100%;border-radius: 0px;background-image: linear-gradient(179deg,' + $bgColor + '0%,' + $bgColor2 + '100%);'">
      <v-btn icon dark @click="closeService">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t("message.packageDetails") }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
      <v-card
        width="93%"
        class="ml-4 mr-4 mb-5 mt-4 rounded"
        elevation="3"
      >
      <div style="display: flex; flex-direction: column;">
          <div style="display: flex; justify-content: center; align-items: center; width: 100%; border-radius: 10px 10px 0 0;">
            <v-img
              :src="choosePackage.packageImg"
              height="100%"
              width="100%"
              class="link"
              style="border-radius: 10px 10px 0 0;"
              contain
            >
            </v-img>
          </div>
            <div class="mt-5" style="padding: 16px; position: relative; width: 100%">
              <div style="display: flex; justify-content: center; align-items: center;" class="font16 bold headline1">{{ $t("message.packageName") }}: {{ choosePackage.packageName }}</div>
              <div class="d-flex mt-5">
                  <div class="col-6">{{ $t("message.service") }}</div>
                  <div class="d-flex justify-content-end col-6">
                    <div>{{ selectedService }}</div>
                  </div>
              </div>
              <div class="d-flex mt-5">
                  <div class="col-6">{{ $t("message.useBefor") }}</div>
                  <div class="d-flex justify-content-end col-6">
                    <div>{{ format_date_thai(choosePackage.exPackage.split(' ').slice(0, -1)) }}</div>
                  </div>
              </div>
              <div class="d-flex mt-5">
                  <div class="col-6">{{ $t("message.usePackage") }}</div>
                  <div class="d-flex justify-content-end col-6">
                    <div class="mr-3">{{ $t("message.total") }}</div>
                    <div class="mr-3">{{ choosePackage.amount }}</div>
                    <div>{{ $t("message.times") }}</div>
                  </div>
                </div>
            </div>
            <v-divider></v-divider>
            <v-list three-line subheader dense class="ml-4">
              <div class="col-12 font16 bold headline1">{{ $t("message.plsSelectbranch") }}</div>
              <div class="d-flex flex-wrap">
                <div class="d-flex justify-content-between col-6" v-for="(item,i) in items2" :key="i">
                  <div justify="center" no-gutters>
                      <v-checkbox
                      v-model="isCheckboxSelected"
                      :label="item.masBranchName"
                      :value="item.masBranchID"
                      @change="pushValueCheckbox(item.masBranchID)"
                      ></v-checkbox>
                  </div>
                </div>
              </div>
            </v-list>
                <v-btn
                  class="bold"
                  :style="'color:' + $textcolor + ';background-color:' + $bgColor +
                  ';text-align: center;display:flex;padding:8px;font-size: 15px;justify-content: center;border-radius: 0 0 5px 5px;'"
                  :disabled="!isCheckboxSelected"
                  @click="handleConfirmation(localSelectedBranchID)"
                  >
                  <div>
                    {{ $t("message.confirmApp") }}
                  </div>
                </v-btn>
          </div>
      </v-card>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  data () {
    return {
      localSelectedBranchID: null,
      isCheckboxSelected: null,
      items2: []
    }
  },
  props: {
    closeService: {
      type: Function
    },
    selectedBranch: {
      type: Function
    },
    choosePackage: {
      type: String,
      default: ''
    },
    selectedService: {
      type: String,
      default: ''
    }
  },
  async mounted () {
    window.scrollTo(0, 0)
    await this.getBranch()
    if (this.items2.length === 1) {
      this.isCheckboxSelected = this.items2[0].masBranchID
      this.pushValueCheckbox(this.isCheckboxSelected)
    }
  },
  methods: {
    async getBranch () {
      const result = await axios.get(
        this.DNS_Link +
          `/master_branch/get?shopId=${this.shopId}`
      )
      // const result = await this.callBeTaskAPI(
      //   'get',
      //   `/master_branch/get?shopId=${this.shopId}`
      // )
      if (result) {
        if (Array.isArray(result.data)) {
          this.items2 = result.data
        }
      }
    },
    pushValueCheckbox (selectedBranchID) {
      this.localSelectedBranchID = selectedBranchID
    },
    handleConfirmation (selectedBranchID) {
      this.selectedBranch(selectedBranchID)
    }
  }
}
</script>
<style scoped>
a.v-tab {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Package/SelectedPackage.vue